export const defaultState = {
  myTrainingRequests: [],
  trainingRequest: null,
};
